export enum EventMasterAttributeEnum {
  ThreeDimension = 1,
  FourDX = 6,
  HFR = 4,
  ATMOS = 8,
  IMAX = 10,
}
